import about, { State as aboutState } from './modules/about';
import { reducer as absenteeBid, State as absenteeBidState } from './modules/absenteeBid';
import addSearchAlert, { State as addSearchAlertState } from './modules/addSearchAlert';
import analytics, { State as analyticsState } from './modules/analytics';
import auctionCalendar, { State as auctionCalendarState } from './modules/auctionCalendar';
import auctionNews, { State as auctionNewsState } from './modules/auctionNews';
import autoPopModal, { State as autoPopModalState } from './modules/autoPopModal';
import { bankAccount, BankAccountState } from './modules/bankAccount';
import bidCountDown, { State as bidCountDownState } from './modules/bidCountDown';
import bidderBiddingInfoAll, { State as bidderBiddingInfoAllState } from './modules/bidderBiddingInfoAll';
import bidderBiddingInfoUpcoming, {
    State as bidderBiddingInfoUpcomingState,
} from './modules/bidderBiddingInfoUpcoming';
import bidderCardStatus, { State as bidderCardStatusState } from './modules/bidderCardStatus';
import bidderExists, { State as bidderExistsState } from './modules/bidderExists';
import biddingInfo, { State as biddingInfoState } from './modules/biddingInfo';
import bidHistory, { State as bidHistoryState } from './modules/bidHistory';
import bidIncrements, { State as bidIncrementsState } from './modules/bidIncrements';
import bidLimit, { State as bidLimitState } from './modules/bidLimit';
import bidLimitExceeded, { State as bidLimitExceededState } from './modules/bidLimitExceeded';
import browser, { State as browserState } from './modules/browser';
import buyNow, { State as buyNowState } from './modules/buyNow';
import catalog, { State as catalogState } from './modules/catalog';
import catalogAd, { State as catalogAdState } from './modules/catalogAd';
import catalogAnnouncement, { State as catalogAnnouncementState } from './modules/catalogAnnouncement';
import catalogCurators, { State as catalogCuratorsState } from './modules/catalogCurators';
import catalogDetail, { State as catalogDetailState } from './modules/catalogDetail';
import catalogFeatured, { State as catalogFeaturedState } from './modules/catalogFeatured';
import catalogItems, { State as catalogItemsState } from './modules/catalogItems';
import catalogLocation, { State as catalogLocationState } from './modules/catalogLocation';
import catalogRegistration, { State as catalogRegistrationState } from './modules/catalogRegistration';
import category, { State as categoryState } from './modules/category';
import categoryCatalogCards, { State as categoryCatalogCardsState } from './modules/categoryCatalogCards';
import changePassword, { State as changePasswordState } from './modules/changePassword';
import checkout, { State as checkoutState } from './modules/checkout';
import cityStateSuggestion, { State as cityStateSuggestionState } from './modules/cityStateSuggestion';
import codex, { State as codexState } from './modules/codex';
import completeAccount, { State as completeAccountState } from './modules/completeAccount';
import config, { State as configState } from './modules/config';
import confirmPassword, { State as confirmPasswordState } from './modules/confirmPassword';
import consent, { State as consentState } from './modules/consent';
import consignment, { State as consignmentState } from './modules/consignment';
import console, { State as consoleState } from './modules/console';
import consoleBranding, { State as consoleBrandingState } from './modules/consoleBranding';
import consoleMessages, { State as consoleMessagesState } from './modules/consoleMessages';
import conversation, { State as conversationState } from './modules/conversation';
import conversationFolders, { State as conversationFoldersState } from './modules/conversationFolders';
import conversationMessages, { State as conversationMessagesState } from './modules/conversationMessages';
import coverLots, { State as coverLotsState } from './modules/coverLots';
import createAccount, { State as createAccountState } from './modules/createAccount';
import creditCard, { State as creditCardState } from './modules/creditCard';
import curatedCollection, { State as curatedCollectionState } from './modules/curatedCollection';
import currency, { State as currencyState } from './modules/currency';
import deleteAccount, { State as deleteAccountState } from './modules/deleteAccount';
import deleteCreditCard, { State as deleteCreditCardState } from './modules/deleteCreditCard';
import discover, { State as discoverState } from './modules/discover';
import discoverPageSuggestions, { State as discoverPageSuggestionsState } from './modules/discoverPageSuggestions';
import emailList, { State as emailListState } from './modules/emailList';
import escrow, { State as escrowState } from './modules/escrow';
import featuredCatalogs, { State as featuredCatalogsState } from './modules/featuredCatalogs';
import featuredCategories, { State as featuredCategoriesState } from './modules/featuredCategories';
import feedback, { State as feedbackState } from './modules/feedback';
import fetchBatch, { State as fetchBatchState } from './modules/fetchBatch';
import followSeller, { State as followSellerState } from './modules/followSeller';
import forgotPassword, { State as forgotPasswordState } from './modules/forgotPassword';
import globalNotification, { State as globalNotificationState } from './modules/globalNotification';
import googleOptimize, { State as googleOptimizeState } from './modules/googleOptimize';
import headerSearchDropdown, { State as headerSearchDropdownState } from './modules/headerSearchDropdown';
import healthcheck, { State as healthcheckState } from './modules/healthcheck';
import home, { State as homeState } from './modules/home';
import imageGalleryActiveImage, { State as imageGalleryActiveImageState } from './modules/imageGalleryActiveImage';
import intl, { State as intlState } from './modules/intl';
import item, { State as itemState } from './modules/item';
import itemDetail, { State as itemDetailState } from './modules/itemDetail';
import itemFacets, { State as itemFacetsState } from './modules/itemFacets';
import itemRemovalResponse, { State as itemRemovalResponseState } from './modules/itemRemovalResponse';
import itemShipping, { State as itemShippingState } from './modules/itemShipping';
import landingPage, { State as landingPageState } from './modules/landingPage';
import listingAgent, { State as listingAgentState } from './modules/listingAgent';
import liveBid, { State as liveBidState } from './modules/liveBid';
import liveCatalogStatus, { State as liveCatalogStatusState } from './modules/liveCatalogStatus';
import liveItemStatus, { State as liveItemStatusState } from './modules/liveItemStatus';
import loaded, { State as loadedState } from './modules/loaded';
import login, { State as loginState } from './modules/login';
import makeOffer, { State as makeOfferState } from './modules/makeOffer';
import modal, { State as modalState } from './modules/modal';
import moreItemsFromCatalogIndex, {
    State as moreItemsFromCatalogIndexState,
} from './modules/moreItemsFromCatalogIndex';
import notification, { State as notificationState } from './modules/notification';
import {
    paginationCookiesReducer,
    DefaultCookieState as paginationCookieState,
    paginationLocalStorageReducer,
} from './modules/pagination';
import passwordReset, { State as passwordResetState } from './modules/passwordReset';
import payment, { State as paymentState } from './modules/payment';
import processingFee, { State as processingFeeState } from './modules/processingFee';
import recentItem, { State as recentItemState } from './modules/recentItem';
import recommendedItem, { State as recommendedItemState } from './modules/recommendedItem';
import registerForCatalog, { State as registerForCatalogState } from './modules/registerForCatalog';
import retractBid, { State as retractBidState } from './modules/retractBid';
import review, { State as reviewState } from './modules/review';
import reviewStatus, { State as reviewStatusState } from './modules/reviewStatus';
import route, { State as routeState } from './modules/route';
import savedItemCount, { State as savedItemCountState } from './modules/savedItemCount';
import { savedSearch, SavedSearchState } from './modules/savedSearch';
import saveItem, { State as saveItemState } from './modules/saveItem';
import saveSearch, { State as saveSearchState } from './modules/saveSearch';
import saveSearchCheck, { State as saveSearchCheckState } from './modules/saveSearchCheck';
import search, { State as searchState } from './modules/search';
import searchExclusions, { State as searchExclusionsState } from './modules/searchExclusions';
import searchFacets, { State as searchFacetsState } from './modules/searchFacets';
import searchPromoted, { State as searchPromotedState } from './modules/searchPromoted';
import searchSuggestions, { State as searchSuggestionsState } from './modules/searchSuggestions';
import seller, { State as sellerState } from './modules/seller';
import sellerCatalogCounts, { State as sellerCatalogCountsState } from './modules/sellerCatalogCounts';
import sellerDetail, { State as sellerDetailState } from './modules/sellerDetail';
import sellerEndedCatalogs, { State as sellerEndedCatalogsState } from './modules/sellerEndedCatalogs';
import sellerFollowerCount, { State as sellerFollowerCountState } from './modules/sellerFollowerCount';
import sellerPreviewCatalogs, { State as sellerPreviewCatalogsState } from './modules/sellerPreviewCatalogs';
import sellerRatings, { State as sellerRatingsState } from './modules/sellerRatings';
import sellerRecordResults, { State as sellerRecordResultsState } from './modules/sellerRecordResults';
import sellerUpcomingCatalogs, { State as sellerUpcomingCatalogsState } from './modules/sellerUpcomingCatalogs';
import sendSellerMessage, { State as sendSellerMessageState } from './modules/sendSellerMessage';
import setPassword, { State as setPasswordState } from './modules/setPassword';
import shipping, { State as shippingState } from './modules/shipping';
import shippingQuote, { State as shippingQuoteState } from './modules/shippingQuote';
import shouldLogin, { State as shouldLoginState } from './modules/shouldLogin';
import signifyd, { State as signifydState } from './modules/signifyd';
import similarItemsCategories, { State as similarItemsCategoriesState } from './modules/similarItemsCategories';
import similarItemsV3, { State as similarItemsV3State } from './modules/similarItemsV3';
import similarSoldItemsV3, { State as similarSoldItemsV3State } from './modules/similarSoldItemsV3';
import smsAlerts, { State as smsAlertsState } from './modules/smsAlerts';
import storefront, { State as storefrontState } from './modules/storefrontPage';
import stripe, { State as stripeState } from './modules/stripe';
import subcategoryTiles, { State as subcategoryTilesState } from './modules/subcategoryTiles';
import taxes, { State as taxesState } from './modules/taxes';
import topRatedSellers, { State as topRatedSellersState } from './modules/topRatedSellers';
import trustMetrics, { State as trustMetricsState } from './modules/trustMetrics';
import upcomingCatalogs, { State as upcomingCatalogsState } from './modules/upcomingCatalogs';
import upcomingItems, { State as upcomingItemsState } from './modules/upcomingItems';
import updateAccount, { State as updateAccountState } from './modules/updateAccount';
import user, { State as userState } from './modules/user';
import userVariantTest, { State as userVariantTestState } from './modules/userVariantTest';
import video, { State as videoState } from './modules/video';
import viewData, { State as viewDataState } from './modules/viewData';
import waitingForApproval, { State as waitingForApprovalState } from './modules/waitingForApproval';
import whiteLabel, { State as whiteLabelState } from './modules/whiteLabel';
import windowSize, { State as windowSizeState } from './modules/windowSize';
import wonItems, { State as wonItemsState } from './modules/wonItems';
import { reducer as certCapture } from './modules/certCapture';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import errors from './modules/errors';
import { reducer as reseller } from './modules/reseller';

export default (history: any) =>
    combineReducers({
        about,
        absenteeBid,
        addSearchAlert,
        analytics,
        auctionCalendar,
        auctionNews,
        autoPopModal,
        bankAccount,
        bidCountDown,
        bidderBiddingInfoAll,
        bidderBiddingInfoUpcoming,
        bidderCardStatus,
        bidderExists,
        biddingInfo,
        bidHistory,
        bidIncrements,
        bidLimit,
        bidLimitExceeded,
        browser,
        buyNow,
        catalog,
        catalogAd,
        catalogAnnouncement,
        catalogCurators,
        catalogDetail,
        catalogFeatured,
        catalogItems,
        catalogLocation,
        catalogRegistration,
        category,
        categoryCatalogCards,
        certCapture,
        changePassword,
        checkout,
        cityStateSuggestion,
        codex,
        completeAccount,
        config,
        confirmPassword,
        consent,
        consignment,
        console,
        consoleBranding,
        consoleMessages,
        conversation,
        conversationFolders,
        conversationMessages,
        coverLots,
        createAccount,
        creditCard,
        curatedCollection,
        currency,
        deleteAccount,
        deleteCreditCard,
        discover,
        discoverPageSuggestions,
        emailList,
        errors,
        escrow,
        featuredCatalogs,
        featuredCategories,
        feedback,
        fetchBatch,
        followSeller,
        forgotPassword,
        globalNotification,
        googleOptimize,
        healthcheck,
        home,
        imageGalleryActiveImage,
        intl,
        item,
        itemDetail,
        itemFacets,
        itemRemovalResponse,
        itemShipping,
        landingPage,
        listingAgent,
        liveBid,
        liveCatalogStatus,
        liveItemStatus,
        loaded,
        login,
        makeOffer,
        modal,
        moreItemsFromCatalogIndex,
        notification,
        pagination: paginationCookiesReducer,
        passwordReset,
        payment,
        persist: combineReducers({
            headerSearchDropdown,
            pagination: paginationLocalStorageReducer,
        }),
        processingFee,
        recentItem,
        recommendedItem,
        registerForCatalog,
        reseller,
        retractBid,
        review,
        reviewStatus,
        route,
        router: connectRouter(history),
        savedItemCount,
        savedSearch,
        saveItem,
        saveSearch,
        saveSearchCheck,
        search,
        searchExclusions,
        searchFacets,
        searchPromoted,
        searchSuggestions,
        seller,
        sellerCatalogCounts,
        sellerDetail,
        sellerEndedCatalogs,
        sellerFollowerCount,
        sellerPreviewCatalogs,
        sellerRatings,
        sellerRecordResults,
        sellerUpcomingCatalogs,
        sendSellerMessage,
        setPassword,
        shipping,
        shippingQuote,
        shouldLogin,
        signifyd,
        similarItemsCategories,
        similarItemsV3,
        similarSoldItemsV3,
        smsAlerts,
        storefront,
        stripe,
        subcategoryTiles,
        taxes,
        topRatedSellers,
        trustMetrics,
        upcomingCatalogs,
        upcomingItems,
        updateAccount,
        user,
        userVariantTest,
        video,
        viewData,
        waitingForApproval,
        whiteLabel,
        windowSize,
        wonItems,
    });

export type GlobalState = {
    about: aboutState;
    absenteeBid: absenteeBidState;
    addSearchAlert: addSearchAlertState;
    analytics: analyticsState;
    auctionCalendar: auctionCalendarState;
    auctionNews: auctionNewsState;
    autoPopModal: autoPopModalState;
    bankAccount: BankAccountState;
    bidCountDown: bidCountDownState;
    bidHistory: bidHistoryState;
    bidIncrements: bidIncrementsState;
    bidLimit: bidLimitState;
    bidLimitExceeded: bidLimitExceededState;
    bidderBiddingInfoAll: bidderBiddingInfoAllState;
    bidderBiddingInfoUpcoming: bidderBiddingInfoUpcomingState;
    bidderCardStatus: bidderCardStatusState;
    bidderExists: bidderExistsState;
    biddingInfo: biddingInfoState;
    browser: browserState;
    buyNow: buyNowState;
    catalog: catalogState;
    catalogAd: catalogAdState;
    catalogAnnouncement: catalogAnnouncementState;
    catalogCurators: catalogCuratorsState;
    catalogDetail: catalogDetailState;
    catalogFeatured: catalogFeaturedState;
    catalogItems: catalogItemsState;
    catalogLocation: catalogLocationState;
    catalogRegistration: catalogRegistrationState;
    category: categoryState;
    categoryCatalogCards: categoryCatalogCardsState;
    changePassword: changePasswordState;
    checkout: checkoutState;
    cityStateSuggestion: cityStateSuggestionState;
    codex: codexState;
    completeAccount: completeAccountState;
    config: configState;
    confirmPassword: confirmPasswordState;
    consent: consentState;
    consignment: consignmentState;
    console: consoleState;
    consoleBranding: consoleBrandingState;
    consoleMessages: consoleMessagesState;
    conversation: conversationState;
    conversationFolders: conversationFoldersState;
    conversationMessages: conversationMessagesState;
    coverLots: coverLotsState;
    createAccount: createAccountState;
    creditCard: creditCardState;
    curatedCollection: curatedCollectionState;
    currency: currencyState;
    deleteAccount: deleteAccountState;
    deleteCreditCard: deleteCreditCardState;
    discover: discoverState;
    discoverPageSuggestions: discoverPageSuggestionsState;
    emailList: emailListState;
    escrow: escrowState;
    featuredCatalogs: featuredCatalogsState;
    featuredCategories: featuredCategoriesState;
    feedback: feedbackState;
    fetchBatch: fetchBatchState;
    followSeller: followSellerState;
    forgotPassword: forgotPasswordState;
    globalNotification: globalNotificationState;
    googleOptimize: googleOptimizeState;
    healthcheck: healthcheckState;
    home: homeState;
    imageGalleryActiveImage: imageGalleryActiveImageState;
    intl: intlState;
    item: itemState;
    itemDetail: itemDetailState;
    itemFacets: itemFacetsState;
    itemRemovalResponse: itemRemovalResponseState;
    itemShipping: itemShippingState;
    landingPage: landingPageState;
    listingAgent: listingAgentState;
    liveBid: liveBidState;
    liveCatalogStatus: liveCatalogStatusState;
    liveItemStatus: liveItemStatusState;
    loaded: loadedState;
    login: loginState;
    makeOffer: makeOfferState;
    modal: modalState;
    moreItemsFromCatalogIndex: moreItemsFromCatalogIndexState;
    notification: notificationState;
    pagination: paginationCookieState;
    passwordReset: passwordResetState;
    payment: paymentState;
    persist: {
        headerSearchDropdown: headerSearchDropdownState;
    };
    processingFee: processingFeeState;
    recentItem: recentItemState;
    recommendedItem: recommendedItemState;
    registerForCatalog: registerForCatalogState;
    retractBid: retractBidState;
    review: reviewState;
    reviewStatus: reviewStatusState;
    route: routeState;
    saveItem: saveItemState;
    saveSearch: saveSearchState;
    saveSearchCheck: saveSearchCheckState;
    savedItemCount: savedItemCountState;
    savedSearch: SavedSearchState;
    search: searchState;
    searchExclusions: searchExclusionsState;
    searchFacets: searchFacetsState;
    searchPromoted: searchPromotedState;
    searchSuggestions: searchSuggestionsState;
    seller: sellerState;
    sellerCatalogCounts: sellerCatalogCountsState;
    sellerDetail: sellerDetailState;
    sellerEndedCatalogs: sellerEndedCatalogsState;
    sellerFollowerCount: sellerFollowerCountState;
    sellerPreviewCatalogs: sellerPreviewCatalogsState;
    sellerRatings: sellerRatingsState;
    sellerRecordResults: sellerRecordResultsState;
    sellerUpcomingCatalogs: sellerUpcomingCatalogsState;
    sendSellerMessage: sendSellerMessageState;
    setPassword: setPasswordState;
    shipping: shippingState;
    shippingQuote: shippingQuoteState;
    shouldLogin: shouldLoginState;
    signifyd: signifydState;
    similarItemsCategories: similarItemsCategoriesState;
    similarItemsV3: similarItemsV3State;
    similarSoldItemsV3: similarSoldItemsV3State;
    smsAlerts: smsAlertsState;
    storefront: storefrontState;
    stripe: stripeState;
    subcategoryTiles: subcategoryTilesState;
    taxes: taxesState;
    topRatedSellers: topRatedSellersState;
    trustMetrics: trustMetricsState;
    upcomingCatalogs: upcomingCatalogsState;
    upcomingItems: upcomingItemsState;
    updateAccount: updateAccountState;
    user: userState;
    userVariantTest: userVariantTestState;
    video: videoState;
    viewData: viewDataState;
    waitingForApproval: waitingForApprovalState;
    whiteLabel: whiteLabelState;
    windowSize: windowSizeState;
    wonItems: wonItemsState;
};
